import { render, staticRenderFns } from "./PastItem.vue?vue&type=template&id=3d32eec6&"
import script from "./PastItem.vue?vue&type=script&lang=ts&"
export * from "./PastItem.vue?vue&type=script&lang=ts&"
import style0 from "./PastItem.vue?vue&type=style&index=0&id=3d32eec6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports